var _g, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHomeinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 17.74"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 1814"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 1813"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 1180",
    d: "M16.481 7.143v9.314h-3.518v-4.03a.64.64 0 00-.64-.64H7.828a.64.64 0 00-.64.64v4.03h-3.5V7.139H2.409v9.957a.64.64 0 00.64.64h4.779a.64.64 0 00.64-.64v-4.03h3.22v4.03a.64.64 0 00.64.64h4.8a.64.64 0 00.64-.64V7.139z",
    fill: "currentColor"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 1816"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 1815"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 1181",
    d: "M19.8 8.85L10.522.169a.64.64 0 00-.87 0L.207 8.846a.64.64 0 00.866.942l9.009-8.277 8.842 8.273a.64.64 0 00.874-.934z",
    fill: "currentColor"
  })))));
}

export default SvgHomeinline;